import { read, update, create } from '@/api/rest';

const projectExecutorQuality = {
  index: async (params) =>
    await read('/project-executor-quality?' + params.toString()),
  userQualities: async () =>
    await read('/project-executor-quality/user-qualities'),
  create: async (data) => await create('/project-executor-quality', data),
  confirm: async (id, data) =>
    await update(`/project-executor-quality/confirm/${id}`, data),
};
export default projectExecutorQuality;
